export const getYtVideoId = (videoUrl: string): string | null => {
  const parts = videoUrl.split('v=');
  if (!parts[1]) return null;
  let videoId = parts[1];
  const ampersandPosition = videoId.indexOf('&');
  if (ampersandPosition !== -1) {
    videoId = videoId.substring(0, ampersandPosition);
  }
  return videoId;
};
